/*
 * This scripts loads Google Maps and Fires a function that alerts anyone interested
 * in the event "googleScriptLoadedAcknowledgement" about google maps installed in
 * the window and ready to be used in whatever needed for particular modules waiting
 * for it existence.
 */
(function googleMapsDownloader(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  const previousGoogleMapsDownloader = global.NewHomeSource.GoogleMapsDownloader;
  const state = {
    loaded: false,
    loading: false
  };

  /**
  * @public
  *
  * sendAckAboutGoogleScriptLoaded: alerts anyone interested about Google Maps loaded and
  * ready to be used.
  */
  function sendAckAboutGoogleScriptLoaded() {
    state.loaded = true;
    state.loading = false;
    document.body.dispatchEvent(new CustomEvent('googleScriptLoadedAcknowledgement'));
  }

  /**
  * @private
  *
  * loadGoogleScript: loads Google Maps script
  */
  function loadGoogleScript() {
    if (global.google && state.loaded) {
      sendAckAboutGoogleScriptLoaded();
      return;
    }

    if (state.loading) {
      return;
    }

    if (global.define) {
      state.loading = true;
      require(['googlemaps!'], sendAckAboutGoogleScriptLoaded);
      return;
    }

    const googleScript = global.document.querySelector('[data-maps-script]');

    if (!googleScript) {
      return;
    }

    state.loading = true;
    googleScript.value += '&callback=sendAcknowledgmentAboutGoogleScriptLoaded';
    global.NHS.loadJs(googleScript.value, 'nhs_GoogleMapScript', null);
  }

  /**
   * @constructs NewHomeSource.GoogleMapsDownloader
   */
  function GoogleMapsDownloader() {
    document.body.addEventListener('askForGoogleScript', () => {
      if (global.google && state.loaded) {
        sendAckAboutGoogleScriptLoaded();
        return;
      }

      if (state.loading) {
        return;
      }

      if (document.readyState === 'complete') {
        loadGoogleScript();
      } else {
        window.addEventListener('load', loadGoogleScript);
      }
    });
  }

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.GoogleMapsDownloader to the previous script.
   */
  GoogleMapsDownloader.noConflict = function noConflict() {
    global.NewHomeSource.GoogleMapsDownloader = previousGoogleMapsDownloader;
    return GoogleMapsDownloader;
  };

  global.sendAcknowledgmentAboutGoogleScriptLoaded = sendAckAboutGoogleScriptLoaded;
  GoogleMapsDownloader();
}(window));
